import {
  Table,
  Dialog,
  Button,
  Divider,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
} from '@mui/material';
import { fNumber } from 'src/utils/format-number';
import { fDate } from 'src/utils/format-time';
import InfoGrid from 'src/components/ui-kit/info-grid';
import { RedeemTxType } from 'src/type/gold-withdraw';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  tx: RedeemTxType;
};

export default function StockExportViewDialog({ open, onClose, tx }: Props) {
  const getInfo = () => {
    if (!tx) return [];

    const { createdAt, updatedAt, product, amount, unitName, pricePerUnit } = tx;

    return [
      { label: 'สินค้า', value: product.name },
      { label: 'จำนวน', value: `${fNumber(amount, 3)} ${unitName}` },
      { label: `ราคา/${unitName}`, value: `${fNumber(pricePerUnit || 0, 3)}` },
      { label: 'วันที่ทำรายการ', value: fDate(createdAt, 'DD MMMM BBBB HH:mm น.') },
      { label: 'อัพเดทล่าสุด', value: fDate(updatedAt, 'DD MMMM BBBB HH:mm น.') },
    ];
  };

  // console.log(tx?.productRedeemFees);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2, display: 'flex' }}>
        ถอนสินค้า
        {tx.product.name} {tx.amount} {tx.unitName || 'บาท'}
      </DialogTitle>

      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="center">จำนวน</TableCell>
                <TableCell align="center">ค่าธรรมเนียม</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {tx?.productRedeemFees?.map((fee) => (
                <TableRow key={fee.id}>
                  <TableCell>{fee?.productRedeemFee?.name}</TableCell>
                  <TableCell align="center">{fNumber(fee?.amount || 0)}</TableCell>
                  <TableCell align="center">{fNumber(fee?.feeTotal || 0)} THB</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Divider style={{ borderStyle: 'dashed' }} />

          <Table size="small" sx={{ mt: 3 }}>
            <TableHead>
              <TableRow>
                <TableCell>น้ำหนักทองทั้งหมด</TableCell>
                <TableCell align="center">
                  {fNumber(tx?.amount || 0)} {tx.unitName || 'บาท'}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>ค่าธรรมเนียมทั้งหมด</TableCell>
                <TableCell align="center">{fNumber(tx?.fee || 0)} THB</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
        <InfoGrid infos={getInfo()} />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
